import React from "react";
import { createRoot } from "react-dom/client"
import App from "./App.js";

const root = createRoot(document.getElementById('moduler-css-app'));

root.render(<App />)